<template>
  <answer-template
    :answer-type="'button template'"
    :input-data="inputData"
    :index="index"
    :isCarousel="isCarousel"
    :wrapper-class="'button-template'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>Button template</template>
    <template v-slot:content>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">Title</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <input
                class="input is-small"
                type="text"
                v-model="inputData.title"
                @keyup="onTextChange"
                placeholder="Title text"
                maxlength="40"
                required
              />
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">Text</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <textarea-autosize
                v-model="inputData.text"
                placeholder="Text"
                rows="1"
                class="textarea is-small"
                :min-height="45"
                :max-height="250"
                maxlength="160"
                @keyup.native="onTextChange"
              ></textarea-autosize>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">Thumbnail</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <input
                type="text"
                class="input is-small"
                v-model="inputData.thumbnailImageUrl"
                @keyup="onTextChange"
                placeholder="Thumbnail Image Url (optional)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label is-small">Buttons</label>
        <div class="control has-fullwidth">
          <div class="tabs is-small is-boxed no-margin">
            <ul class="no-padding">
              <li
                v-for="(btn, index) in inputData.buttons"
                :class="{'is-active': index == activeTab}"
                :key="uid+'-'+index"
              >
                <a @click="activeTab = index">
                  <span class="truncate">{{getLabel(index, btn)}}</span>
                  <span class="icon is-small remove-btn" @click.prevent="deleteButton(index)">
                        <font-awesome-icon icon="times"></font-awesome-icon>
                      </span>
                </a>
              </li>
              <li v-if="inputData.buttons.length < 3 && !inputData.isDefaultCarousel">
                <button class="button is-white is-small" @click="addButton">
                      <span class="icon">
                        <font-awesome-icon icon="plus"></font-awesome-icon>
                      </span>
                  <span>Button</span>
                </button>
              </li>
            </ul>
          </div>
          <div class="tab-box" v-if="selectedButton">
            <div class="field">
              <div class="control is-expanded">
                <input
                  type="text"
                  class="input is-small"
                  v-model="selectedButton.label"
                  placeholder="Button label"
                  maxlength="20"
                  :disabled="inputData.isDefaultCarousel"
                />
              </div>
            </div>
            <div class="field has-addons">
              <div class="control">
                <div class="select is-small">
                  <select v-model="selectedButton.type" @change="toggleType" :disabled="inputData.isDefaultCarousel">
                    <option value="text_button">Text</option>
                    <option value="uri_button">Uri</option>
                    <option v-if="dataInSameLevel && dataInSameLevel.length > 0" value="category_button">Category</option>
                  </select>
                </div>
              </div>
              <div class="control is-expanded">
                <input
                  v-if="selectedButton.type === 'text_button'"
                  type="text"
                  class="input is-small"
                  v-model="selectedButton.text"
                  @keyup="onTextChange"
                  placeholder="Text"
                  maxlength="300"
                />
                <input
                  v-else-if="selectedButton.type === 'uri_button'"
                  type="text"
                  class="input is-small"
                  v-model="selectedButton.uri"
                  @keyup="onTextChange"
                  placeholder="Uri"
                  maxlength="1000"
                />
                <select
                  v-else-if="selectedButton.type === 'category_button' && categoryList && categoryList.length"
                  class="input is-small"
                  v-model="selectedButton.payload"
                  @change="onTextChange"
                  :disabled="inputData.isDefaultCarousel || categoryList && categoryList.length === 0"
                >
                  <option v-if="!selectedButton.payload" value="" disabled selected>Select category</option>
<!--                  <option v-for="data in categoryList" :key="data.id" :value="selectedButton.payload === data.id ? selectedButton.payload : data.categoryId">-->
                  <option v-for="data in categoryList" :key="data.id" :value="data.id">
                    {{ data.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from './AnswerTemplate.vue';

export default {
  name: 'buttonTemplate',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: 'button_template',
          thumbnailImageUrl: '',
          title: '',
          text: '',
          buttons: [],
        };
      },
    },
    index: {
      type: Number,
    },
    uid: {
      type: String,
    },
    isCarousel: {
      type: Object,
      default() {
        return {
          index: 0
        };
      },
    },
    dataInSameLevel: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  mounted() {
    this.activeTab = 0;
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    addButton() {
      this.inputData.buttons.push({
        type: 'text_button',
        label: '',
        // text: '',
        // uri: '',
        // payload: '',
      });
      this.toggleDirty();
    },
    deleteButton(index) {
      this.inputData.buttons.splice(index, 1);
      setTimeout(() => {
        this.activeTab = 0;
      });
      this.toggleDirty();
    },
    getLabel(index, btn) {
      if (btn && btn.label) {
        return btn.label;
      }
      return `Button ${index + 1}`;
    },
    toggleDirty() {
      this.$emit('dirty');
    },
    onTextChange() {
      this.toggleDirty();
    },
    toggleType() {
      const button = this.selectedButton;
      if (button) {
        if (button.type === 'uri_button') {
          button.uri = '';
          delete button.text;
          delete button.payload;
        } else if (button.type === 'text_button') {
          button.text = '';
          delete button.uri;
          delete button.payload;
        } else if (button.type === 'category_button') {
          button.payload = '';
          delete button.uri;
          delete button.text;
        }
      }
      this.toggleDirty();
    },
  },
  computed: {
    selectedButton() {
      return this.inputData.buttons[this.activeTab] || false;
    },
    categoryList() {
      if (this.dataInSameLevel && this.dataInSameLevel.length) {
        return this.dataInSameLevel;
      }
      return [];
    }
  },
};
</script>
<style lang="scss" scoped>
.button-template {
  .is-subtitle {
    font-size: 14px;
    font-weight: 600;
    line-height: 23px;
    color: #444;
  }
  .answer-box {
    width: 100%;
    .has-fullwidth {
      width: 100%;
    }
    .tab-box {
      border: 1px solid #ddd;
      border-top: none;
      padding: 10px;
      border-radius: 0 0 5px 5px;
    }
    .remove-btn {
      color: #ddd;
      &:hover {
        color: #ff3860;
      }
    }
    .truncate {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
